module.exports = __webpack_public_path__ + "static/img/bg2.712069d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg2.png
// module id = PU4a
// module chunks = 2